import React from 'react'
import TableArmoire from '../../../Components/table/TableArmoire'

const Armoires = () => {
  return <TableArmoire />
}

export default Armoires
